// action types for tags
export const SET_LOTSTAGS_LIST = "SET_LOTSTAGS_LIST";
export const ADD_LOTSTAG = "ADD_LOTSTAG";
export const UPDATE_LOTSTAG = "UPDATE_LOTSTAG";
export const DELETE_LOTSTAG = "DELETE_LOTSTAG";
